import type { LucideIcon } from "lucide-react"
import { FileQuestion } from "lucide-react"
import type { ReactNode } from "react"
import { Skeleton } from "@/shared/ui/skeleton"

export function EmptyState({
	icon: Icon = FileQuestion,
	title,
	children,
	action,
}: {
	icon?: LucideIcon
	title: string
	children?: ReactNode
	action?: ReactNode
}) {
	return (
		<div className="rounded-2xl border border-dashed border-foreground/15 bg-card/40 px-6 py-12 text-center">
			<Icon className="mx-auto mb-3 size-8 text-muted-foreground" />
			<p className="font-medium">{title}</p>
			{children ? <div className="mt-1 text-sm text-muted-foreground">{children}</div> : null}
			{action ? <div className="mt-4">{action}</div> : null}
		</div>
	)
}

export function TableSkeleton({ rows = 5 }: { rows?: number }) {
	return (
		<div className="space-y-2">
			{Array.from({ length: rows }).map((_, index) => (
				<Skeleton key={index} className="h-12 w-full rounded-lg" />
			))}
		</div>
	)
}
